import MarkerDock from '../../../images/marker-dock.svg'
import MarkerDrone from '../../../images/marker-drone.svg'
import MarkerHub from '../../../images/marker-hub.svg'

export const buildDockEntity = ({ cesiumViewer, id, name, position }) => {
  return cesiumViewer.entities.add({
    position,
    id,
    name,
    billboard: {
      image: MarkerDock,
      scaleByDistance: new Cesium.NearFarScalar(1.5e2, 0.2, 1.5e7, 0.1)
    }
  })
}

export const buildDroneCzmlPackage = ({ droneId, droneName, latitude, longitude, elevation, timestamp }) => {
  const currentTime = new Date(timestamp)
  const currentTimeIso = currentTime.toISOString()

  // 120 minute ago
  const startTimeIso = new Date(currentTime.getTime() - 120 * 60 * 1000).toISOString()
  // 1 minute from now
  const endTimeIso = new Date(currentTime.getTime() + 120 * 60 * 1000).toISOString()

  const documentInterval = startTimeIso + '/' + endTimeIso

  // Construct the CZML object for the path
  return [
    {
      id: 'document',
      version: '1.0',
      clock: {
        interval: documentInterval,
        currentTime: currentTimeIso,
        multiplier: 1
      }
    },
    {
      id: droneId,
      name: droneName,
      availability: documentInterval,
      path: {
        material: {
          solidColor: {
            color: {
              rgba: [255, 255, 0, 188]
            }
          }
        },
        width: 3,
        show: true
      },
      position: {
        interpolationAlgorithm: 'LAGRANGE',
        interpolationDegree: 2,
        forwardExtrapolationType: 'HOLD',
        epoch: startTimeIso,
        cartographicDegrees: [
          currentTimeIso, longitude, latitude, elevation
        ]
      },
      billboard: {
        image: MarkerDrone,
        scaleByDistance: {
          nearFarScalar: [1.5e2, 0.3, 1.5e6, 0.15]
        }
      }
    }
  ]
}

export const buildHubEntity = ({ cesiumViewer, id, name, position }) => {
  return cesiumViewer.entities.add({
    position,
    id,
    name,
    billboard: {
      image: MarkerHub,
      pixelOffset: new Cesium.Cartesian2(0, -21),
      pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
        150.0, 1.5,
        1.5e7, 0.5
      ),
      scaleByDistance: new Cesium.NearFarScalar(1.5e2, 0.2, 1.5e7, 0.1)
    }
  })
}
